<template>
  <div class="header-section">
    <div class="header-bottom">
      <div class="container">
          <nav class="navbar navbar-expand-lg">
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
              <span class="menu-toggle"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
              <ul class="navbar-nav main-menu">
                <li><router-link to="/">home</router-link></li>

                <li class="menu_has_children">
                  <router-link to="">shop</router-link>
                  <ul class="sub-menu">
                    <li><router-link to="/shop">shop</router-link></li>
                    <li><router-link to="/newproducts">new products</router-link></li>
                    <li><router-link to="/featureproducts">features products</router-link></li>
                    <li><router-link to="/cart">cart</router-link></li>
                    <li><router-link to="/faq">faq</router-link></li>
                    <li><router-link to="/offer">offer</router-link></li>
                    <li><router-link to="/maps">map</router-link></li>
                  </ul>
                </li>

                <li class="menu_has_children">
                  <router-link to="">categories</router-link>
                  <ul class="sub-menu">
                    <li><router-link to="/desktop">desktop</router-link></li>
                    <li><router-link to="/laptop">laptop</router-link></li>
                    <li><router-link to="/netbook">netbook</router-link></li>
                    <li><router-link to="/tablet">tablet</router-link></li>
                    <li><router-link to="/phone">phone</router-link></li>
                    <li><router-link to="/camera">camera</router-link></li>
                    <li><router-link to="/others">others</router-link></li>
                  </ul>
                </li>

                <li class="menu_has_children">
                  <router-link to="">my account</router-link>
                  <ul class="sub-menu">
                    <li><router-link to="/login">login</router-link></li>
                    <li><router-link to="/cart">cart</router-link></li>
                  </ul>
                </li>

                <li><router-link to="/about">about</router-link></li>
                <li><router-link to="/contact">contact</router-link></li>
              </ul>
            </div>
          </nav>
      </div>
    </div><!-- header-bottom end -->
  </div>

</template>

<script>
  export default {
    mounted() {
      this.menuAffix();
      this.mobileMenu();
      this.responsiveMenuSliding();
    },
    methods: {
      menuAffix() {
        var fixed_top = $(".header-section");
        $(window).on("scroll", function(){
            if( $(window).scrollTop() > 50){
                fixed_top.addClass("animated fadeInDown menu-fixed");
            }
            else{
                fixed_top.removeClass("animated fadeInDown menu-fixed");
            }
        })
      },
      mobileMenu() {
        $(".menu-toggle").on("click", function() {
         $(this).toggleClass("is-active");
        });
      },
      responsiveMenuSliding() {
        if ($(window).width() < 992) {
          $(".navbar-collapse>ul>li>a, .navbar-collapse ul.sub-menu>li>a").on("click", function() {
            var element = $(this).parent("li");
            if (element.hasClass("open")) {
              element.removeClass("open");
              element.find("li").removeClass("open");
              element.find("ul").slideUp(500,"linear");
            }
            else {
              element.addClass("open");
              element.children("ul").slideDown();
              element.siblings("li").children("ul").slideUp();
              element.siblings("li").removeClass("open");
              element.siblings("li").find("li").removeClass("open");
              element.siblings("li").find("ul").slideUp();
            }
          });

        }
      }
    }
  }
</script>



<style scoped>

  /* menu toggle */
  span.is-active {
    border-color: transparent;
  }
  span.is-active:before {
    -webkit-transform: translate(-50%, -50%) rotate(45deg);
            -ms-transform: translate(-50%, -50%) rotate(45deg);
        transform: translate(-50%, -50%) rotate(45deg);
  }
  span.is-active:after {
    -webkit-transform: translate(-50%, -50%) rotate(-45deg);
    -ms-transform: translate(-50%, -50%) rotate(-45deg);
    transform: translate(-50%, -50%) rotate(-45deg);
  }
  span.menu-toggle:hover {
    color: #eb1b33;
  }
  span.is-active {
    border-color: transparent;
  }
  span.is-active:before {
    -webkit-transform: translate(-50%, -50%) rotate(45deg);
            -ms-transform: translate(-50%, -50%) rotate(45deg);
        transform: translate(-50%, -50%) rotate(45deg);
  }
  span.is-active:after {
    -webkit-transform: translate(-50%, -50%) rotate(-45deg);
            -ms-transform: translate(-50%, -50%) rotate(-45deg);
        transform: translate(-50%, -50%) rotate(-45deg);
  }

/* menu affix css */
  .animated {
    -webkit-animation-duration: 1s;
    animation-duration: 1s;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
  }

  @-webkit-keyframes fadeInDown {
    from {
      opacity: 0;
      -webkit-transform: translate3d(0, -100%, 0);
      -ms-transform: translate3d(0, -100%, 0);
      transform: translate3d(0, -100%, 0);
    }
    to {
      opacity: 1;
      -webkit-transform: none;
      -ms-transform: none;
      transform: none;
    }
  }
  @keyframes fadeInDown {
    from {
      opacity: 0;
      -webkit-transform: translate3d(0, -100%, 0);
      -ms-transform: translate3d(0, -100%, 0);
      transform: translate3d(0, -100%, 0);
    }
    to {
      opacity: 1;
      -webkit-transform: none;
      -ms-transform: none;
      transform: none;
    }
  }
  .fadeInDown {
    -webkit-animation-name: fadeInDown;
    animation-name: fadeInDown;
  }

  /* responsive */
  @media (max-width: 991px) {
    .navbar-collapse {
      margin: 0 -15px;
      padding: 15px 30px;
      background-color: #f2f2f2;
    }
    .main-menu li a {
      padding: 8px 0;
      display: block;
    }
    .main-menu li .sub-menu {
      position: static;
      opacity: 1;
      visibility: visible;
      display: none;
      transition: none;
      -webkit-transition: none;
      -moz-transition: none;
      -ms-transition: none;
      -o-transition: none;
      width: 100%;
      box-shadow: 0px 1px 4px 0px rgba(0,0,0,0.15);
      -webkit-box-shadow: 0px 1px 4px 0px rgba(0,0,0,0.15);
    }
    .sub-menu li a {
      padding: 6px 30px;
    }
    li.menu_has_children:after {
      top: 8px;
      right: 60%;
    }
  }
  @media (max-width: 767px) {
    .navbar-collapse {
      max-height: 320px;
      overflow-y: scroll;
    }
  }
</style>
